<template>
    <div class="not-found">
      <h1>Oops! Seite nicht gefunden.</h1>
      <p>Es sieht so aus, als hätten wir uns verlaufen. Aber keine Sorge, wir haben einen Kompass!</p>
      <router-link to="/">Zurück zur Startseite</router-link>
    </div>
</template>

<script>
    export default {
        name: 'FourOFour',
        props:[
            "catchAll"
        ]
    }
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 50px;
  background-color: #00000069;
  padding:15px;
}
h1 {
  font-size: 3em;
  color: #ff6f61;
}
p {
  font-size: 1.5em;
  margin: 20px 0;
  color: white;
}
a {
  text-decoration: none;
  color: #4CAF50;
  font-weight: bold;
}
</style>